import { MessageType } from '../../hooks/useSocket/useSocket.types'

export enum ChatViewMode {
  full,
  small
}

export type ChatProps = {
  listMessages: MessageType[]
  isNotificationsEnabled?: boolean
  onChangeSettings: (value: boolean) => void
  user: string | null
  isUserConnected: boolean
  chatListRef: React.RefObject<HTMLUListElement>
  onToggleChat: () => void
  isChatOpened: boolean
  title?: string
  isGameChat?: boolean
  viewMode?: ChatViewMode
  changeViewMode?: (value: ChatViewMode) => void
}
